export default function Logo({ size = 36, textSize = "text-xl", showWord = true, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/logo.png"
        alt="Rim Task"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain", display: "block" }}
        className="flex-shrink-0"
      />
      {showWord && (
        <span className={`font-heading font-black tracking-tight ${textSize} whitespace-nowrap`}>
          Rim Task
        </span>
      )}
    </div>
  );
}
